const BASE_SERVER_PATH = 'https://p5afw4zfc3.execute-api.ap-southeast-1.amazonaws.com/prod/api'
// const BASE_SERVER_PATH = 'http://localhost:3000/api'
export default {
  BASE_SERVER_PATH: BASE_SERVER_PATH
}
